import { useQuery } from '@tanstack/react-query'
import { parseQueryParams } from '../../../../utilities/parsers'
import apiUrl from '../../../../apis/api.url'
import { getData } from '../../../../apis/api.helpers'
import { useAuthStore } from '../../../../store/authStore'

const buildUrlWithParams = (baseUrl: string) => {
  return `${baseUrl}${parseQueryParams()}`
}
const buildUrlWithFilters = (
  baseUrl: string,
  filters: Record<string, any> = {}
) => {
  const params = new URLSearchParams()

  // Add each filter to the params if it has a value
  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      if (Array.isArray(value)) {
        // Handle array values (like multiple role IDs)
        value.forEach((v) => params.append(key, v))
      } else if (typeof value === 'object' && value instanceof Date) {
        // Handle Date objects
        params.append(key, value.toISOString())
      } else {
        // Handle simple values
        params.append(key, value.toString())
      }
    }
  })

  // Combine with existing query params if any
  const existingParams = parseQueryParams()
  const combinedParams = existingParams
    ? `${existingParams}&${params.toString()}`
    : `?${params.toString()}`

  return `${baseUrl}${combinedParams}`
}
const fetchBanner = async () => {
  const url = buildUrlWithParams(apiUrl.BANNER_LIST)
  const response = await getData(url)
  return response
}
const fetchBannerUser = async () => {
  const url = buildUrlWithParams(apiUrl.BANNER_LIST_USER)
  const response = await getData(url)
  return response
}

export const useBannerList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)
  return useQuery(
    ['members_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchBannerUser()
      } else {
        return fetchBanner()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchTestimonial = async () => {
  const url = buildUrlWithParams(apiUrl.TESTIMONIALS)
  const response = await getData(url)
  return response
}
const fetchTestimonialUser = async () => {
  const url = buildUrlWithParams(apiUrl.TESTIMONIALS)
  const response = await getData(url)
  return response
}

export const useTestimonialList = () => {
  const authenticated = useAuthStore((state) => state.authenticated)

  return useQuery(
    ['testimonials_listing', authenticated],
    () => {
      if (authenticated) {
        return fetchTestimonialUser()
      } else {
        return fetchTestimonial()
      }
    },
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchAdvertisement = async () => {
  const url = buildUrlWithParams(apiUrl.ADVERTISEMENT_LIST)
  const response = await getData(url)
  return response
}

export const useFetchAdvertisement = () => {
  return useQuery(['worker_jobtype_listing'], () => fetchAdvertisement(), {
    refetchOnWindowFocus: false,
  })
}
const fetchYoutubeVideos = async () => {
  const url = buildUrlWithParams(apiUrl.VIDEOS)
  const response = await getData(url)
  return response
}

export const useYoutubeVideos = () => {
  return useQuery(['videos_listing'], () => fetchYoutubeVideos(), {
    refetchOnWindowFocus: false,
  })
}

const tranningCalender = async (filters: Record<string, any> = {}) => {
  const url = buildUrlWithFilters(apiUrl.TRAININGCALENDAR, filters)
  const response = await getData(url)
  return response
}

// Update the useTranningCalender hook to accept filters
export const useTranningCalender = (filters: Record<string, any> = {}) => {
  return useQuery(
    ['tranning-calender', filters],
    () => tranningCalender(filters),
    {
      refetchOnWindowFocus: false,
    }
  )
}
const fetchPartners = async () => {
  const url = buildUrlWithParams(apiUrl.PARTNER_LIST)
  const response = await getData(url)
  return response
}

export const usePartners = () => {
  return useQuery(['partners_listing'], () => fetchPartners(), {
    refetchOnWindowFocus: false,
  })
}
const fetchPhotos = async () => {
  const url = buildUrlWithParams(apiUrl.PHOTO_LIST)
  const response = await getData(url)
  return response
}

export const usePhotos = () => {
  return useQuery(['photo_listing'], () => fetchPhotos(), {
    refetchOnWindowFocus: false,
  })
}
